<template>
  <a-modal :centered="true" :confirmLoading="confirmLoading" :destroyOnClose="true" :visible="visible" title="库房补货规则" width="50%" @cancel="handleCancel" @ok="handleOk">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="rule" :rules="rules" :wrapper-col="wrapperCol" style="margin-left: -2%;margin-right: 2%">
      <a-row>
        <a-col span="12">
          <a-form-model-item ref="no" label="补出库房" prop="sourceStorageRoom">
            <a-input v-model="rule.sourceStorageRoom.name" allowClear @change="(e,fieldName)=>change(e,fieldName)" @dblclick="search('storageRoomModal',{storageRoomType:1,available:true},'sourceStorageRoom')" @pressEnter="search('storageRoomModal',{storageRoomType:1,available:true},'sourceStorageRoom')"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item ref="no" label="补入库房" prop="targetStorageRoom">
            <a-input v-model="rule.targetStorageRoom.name" allowClear @change="(e,fieldName)=>change(e,fieldName)" @dblclick="search('storageRoomModal',{storageRoomType:1,available:true},'targetStorageRoom')"
                     @pressEnter="search('storageRoomModal',{storageRoomType:1,available:true},'targetStorageRoom')"/>
          </a-form-model-item>
        </a-col>
        <storage-room-modal ref="storageRoomModal" @change="(e,fieldName)=>change(e[0],fieldName)"/>
      </a-row>
      <a-row>
        <a-col span="12">
          <a-form-model-item label="索取次数" prop="times">
            <a-input-number v-model="rule.times" :max="2" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :wrapper-col="labelCol" label="交接">
            <vxe-switch v-model="rule.handover" size="mini"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="12">
          <a-form-model-item label="传输类型" prop="transmissionType">
            <a-select v-model="rule.transmissionType" :options="transmissionTypes"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { save } from '@/api/Api'
import { ReplenishmentRule } from '@/api/dto/config/ReplenishmentRule'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import { Identifier } from '@/api/dto/Identifier'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { Warehouse } from '@/api/dto/common/Warehouse'
import { StorageRoom } from '@/api/dto/common/StorageRoom'

export default {
  name: 'StorageRoomReplenishmentRuleModal',
  components: { StorageRoomModal },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      rule: new ReplenishmentRule(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        'sourceStorageRoom': [{ required: true, message: '补出库房不能为空' }],
        'targetStorageRoom': [{ required: true, message: '补入库房不能为空' }],
        'times': [{ required: true, message: '索取次数不能为空' }],
        'transmissionType': [{ required: true, message: '传输类型不能为空' }]
      }
    }
  },
  props: {
    transmissionTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    add(storageRoom) {
      this.visible = true
      this.rule = new ReplenishmentRule()
      if (storageRoom !== null && storageRoom !== undefined) {
        this.rule.targetStorageRoom = Object.assign(new StorageRoom(), storageRoom)
      }
      this.rule.warehouse = Object.assign(new Warehouse(), this.warehouse)
    },
    edit(record) {
      this.visible = true
      this.rule = new ReplenishmentRule(record)
      this.rule.warehouse = Object.assign(new Warehouse(), this.warehouse)
    },
    search(refName, args, fieldName) {
      this.$refs[refName].open(args, fieldName)
    },
    change(changeData, fieldName) {
      this.rule[fieldName] = changeData ? Object.assign(new Identifier(), changeData) : new Identifier()
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.confirmLoading = true
          let saveData = new ReplenishmentRule()
          Object.assign(saveData, this.rule)
          saveData.warehouse = saveData.warehouse.skipNulls()
          saveData.sourceStorageRoom = saveData.sourceStorageRoom.skipNulls()
          saveData.targetStorageRoom = saveData.targetStorageRoom.skipNulls()
          save('replenishmentRulePersister', saveData).then(res => {
            if (res.success) {
              this.rule = new ReplenishmentRule(res.result)
              this.$success({
                title: '提示',
                content: '保存成功',
                centered: true
              })
              this.$emit('saveSuccess')
              this.handleCancel()
            }
          }).finally(() => this.confirmLoading = false)
        }
      })
    },
    handleOk() {
      this.save()
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>